import { CanDeactivateFn } from '@angular/router';

interface CollaboraCloseAware {
  prepareForCollaboraClose(): Promise<void>;
}

export const collaboraCloseGuard: CanDeactivateFn<CollaboraCloseAware> = async (component) => {
  await component.prepareForCollaboraClose();
  return true;
};